import { SERVER_URL } from "./../env";

export const formatDateTime = d => {
  const month = d.getMonth() + 1;

  return `${d.getFullYear()}-${month.toString().padStart(2, "0")}-${d
    .getDate()
    .toString()
    .padStart(2, "0")}T${d
    .getHours()
    .toString()
    .padStart(2, "0")}:${d
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;
};

export const formatDate = (year, month, day) => {
  return `${year}-${month
    .toString()
    .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
};

export const formatToHtml = str => {
  const regex = /(&lt;)(.*?)(&gt;)/gi;
  return str.replace(regex, "<$2>");
};

export const loadAvatar = imgUrl => {
  if (imgUrl) {
    return SERVER_URL + imgUrl;
  }
  return require("@/assets/img/default-2.png");
};
